export default __webpack_public_path__ + "static/media/project1.efc7ef15.png";